import { actionTypes } from './constants';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { searchAttendeesStatsByEventApi } from 'src/redesign/features/AttendeeStats/api';
import { AttendeeStatsPayload } from 'src/redesign/features/AttendeeStats/types';
import { ATTENDEES_PER_PAGE } from '../Attendees/constants';

export const searchAttendeesStatsByEvent = createAsyncThunk(
  actionTypes.FETCH_ATTENDEE_STATS,
  async ({ eventId, offset = 0, limit = ATTENDEES_PER_PAGE, criteria }: AttendeeStatsPayload) => {
    return await searchAttendeesStatsByEventApi({
      eventId,
      offset,
      limit,
      criteria,
    });
  },
);
